// imports
import Model from '$dependencies/Model';
import Config from '../../Config';

const FIELDS = {
	uuid: { type: String, default: '', identifier: true },
	title: {type: String, default: ''},
	created: {type: String, default: ''},
	emailAddress: {type: String, default: ''},
	postalCodes: {type: Array, default: () => []},
	administrators: {type: Object, default: () => {}},
	categories: {type: Array, default: () => []},
	headCommunity: {type: Boolean, default: () => false},
	binsQr: {type: Boolean, default: true},
	bins_qr: {type: Boolean, default: true},
};

// class definition
export default class CommunityModel extends Model {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.fields = FIELDS;

		// call super constructor
		super(args);
	}

	fetch(data) {
		this.setConfig('url', `${Config.getUrl('c_community')}`);
		return super.fetch(data);
	}

	parse(data) {
		return super.parse(data?.data);
	}

	patch(data, options = {}) {
		// run super patch
		this.setConfig('url', `${Config.getUrl('c_community')}`);
		return super.patch(prepareDataForPatch(cleanUpPatchFields(data || this.toObject(true), options.fieldsToPatch)));
	}
}

function prepareDataForPost(data) {
	return data;
}

function prepareDataForPatch(data) {
	return data;
}

function cleanUpPatchFields(data, fieldsToPatch) {
	if (!fieldsToPatch) return data;
	if (data && fieldsToPatch) {
		for (const field in data) {
			if (!fieldsToPatch.includes(field)) {
				delete data[field];
			} else if(field === 'postalCodes') {
				data[field].forEach(pc => {
					delete pc.isHighlighted;
					delete pc.isAccordionOpen;
					delete pc.title;
					delete pc.headCommunity;
					delete pc.headCommunityTitle;
				})
			}
		}
	}
	return data;
}
